import { useState } from "react";

export default function Textarea({
  label,
  hint,
  error,
  value,
  defaultValue,
  placeholder,
  rows = 4,
  disabled = false,
  id,
  onChange,
  style,
  ...rest
}) {
  const [focus, setFocus] = useState(false);
  const inputId = id || (label ? `ta-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  const borderColor = error ? "var(--danger)" : focus ? "var(--brand)" : "var(--border-default)";

  const field = {
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    resize: "vertical",
    background: disabled ? "var(--surface-sunken)" : "var(--surface-raised)",
    border: `1px solid ${borderColor}`,
    borderRadius: "var(--radius-md)",
    padding: "12px 14px",
    fontFamily: "var(--font-body)",
    fontSize: "var(--text-base)",
    lineHeight: "var(--leading-normal)",
    color: "var(--text-primary)",
    outline: "none",
    boxShadow: focus && !error ? "var(--shadow-focus)" : "none",
    transition: "border-color var(--dur-base) var(--ease-standard), box-shadow var(--dur-base) var(--ease-standard)",
    opacity: disabled ? 0.6 : 1,
  };

  return (
    <label htmlFor={inputId} style={{ display: "block", fontFamily: "var(--font-body)", ...style }}>
      {label && (
        <span style={{ display: "block", fontSize: "var(--text-sm)", fontWeight: "var(--weight-semibold)", color: "var(--text-primary)", marginBottom: 6 }}>
          {label}
        </span>
      )}
      <textarea
        id={inputId}
        rows={rows}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        style={field}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        {...rest}
      />
      {(hint || error) && (
        <span style={{ display: "block", fontSize: "var(--text-xs)", color: error ? "var(--danger)" : "var(--text-muted)", marginTop: 5 }}>
          {error || hint}
        </span>
      )}
    </label>
  );
}
